import React from 'react';

interface HomeImageProps {
  bannerImage: string;
  fallbackSrc?: string;
  altText?: string;
  className?: string;
}

export default function HomeImage({
  bannerImage,
  fallbackSrc = '',
  altText = 'Landing Banner',
  className = 'w-full',
}: HomeImageProps) {
  const src = bannerImage !== '' ? bannerImage : fallbackSrc;

  return (
    <img alt={altText} src={src} className={`object-cover ${className}`} />
  );
}
